export const compute = (p) => (typeof p === "function" ? p() : p)
